import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class BackgroundService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  listBackgrounds = ({ categoryIDs, categoryID, page, max_results }) => {
    const request = {
      method: 'GET',
      url: '/backgrounds',
      params: {
        categoryIDs: categoryIDs && categoryIDs.join(','),
        category_id: categoryID,
        page,
        max_results: max_results || 30,
      },
    };
    return this.axios(request);
  };

  insertDbOfBackground = (params) => {
    const { uploadKeys, subCat } = params;
    const request = {
      method: 'POST',
      url: '/backgrounds',
      data: {
        backgrounds: uploadKeys,
        category_id: subCat,
      },
    };
    return this.axios(request);
  };

  getUrlOfItem = (id) => {
    const request = {
      method: 'POST',
      url: '/backgrounds/download',
      data: {
        id,
      },
    };
    return this.axios(request);
  };
}

export default new BackgroundService();
